import React from "react";
import PropTypes from "prop-types";
import OneCol, { Row } from "layouts/OneCol";
import Header from "components/views/Header";
import T from "i18n";
import PageHeading from "components/views/atoms/PageHeading";
import ProgressHeading from "components/views/ProgressHeading";
import EndOfPageNotes from "components/views/EndOfPageNotes";
import OutlinedMoreHelp from "components/views/OutlinedMoreHelp";
import OutlinedLinksGrid from "components/views/OutlinedLinksGrid";
import CatalystFitted from "components/containers/CatalystFitted";
import Footer from "components/views/atoms/Footer";

const Catalyst = ({ className, breadcrumbs }) => {
  const classes = ["Catalyst"];
  if (className) classes.push(className);
  const bc = breadcrumbs.map((b) => b());

  return (
    <OneCol className={classes.join(" ")}>
      <Header heading="Commercial" />
      <PageHeading>
        <T path="common.productSelector" />
      </PageHeading>

      <Row fullWidth>
        <ProgressHeading
          perc={90}
          heading={T({ path: "catalystPage.progressHeading" })}
          breadcrumbSteps={bc}
        />
      </Row>

      <Row>
        <CatalystFitted />
      </Row>

      <Row>
        <OutlinedLinksGrid>
          <OutlinedMoreHelp LinkLabel={T({ path: "button.moreHelpUrl" })} />
        </OutlinedLinksGrid>
      </Row>

      <Row>
        <EndOfPageNotes />
      </Row>

      <Footer />
    </OneCol>
  );
};

Catalyst.displayName = "Catalyst";

Catalyst.propTypes = {
  className: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.func),
};

Catalyst.defaultProps = {
  className: null,
  breadcrumbs: [],
};

export default Catalyst;
